/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         12/05/25 - 11:58:27
 * Module name:  expired-manage-token
 * File name:    expired-manage-token.ts
 * IDE:          WebStorm
 */

import {InjectionToken} from '@angular/core';

export const EXPIRED_MANAGE_TOKEN = new InjectionToken<string>('EXPIRED_MANAGE_TOKEN');
